const sidemenuVuexModule = {
  state: {
    appVersion: process.env.VUE_APP_VERSION,
    currentPage: undefined,
    loading: false
  },

  mutations: {
    setCurrentPage (state, page) { state.currentPage = page; },
    setLoading (state, loading) { state.loading = loading; }
  },

  getters: {
    appVersion: state => state.appVersion,
    currentPage: state => state.currentPage,
    loading: state => state.loading,
    activateMenuIcon: state => state.currentPage != undefined
  }
};

export default sidemenuVuexModule;
